import { CustomError } from 'ts-custom-error';

export class InvalidBreakpointError extends CustomError {
  public constructor(breakpoint: string) {
    super(`Invalid breakpoint: "${breakpoint}"`);
  }
}
